import ChangePasswordIcon from "../assets/icons/changePasswordIcon.tsx";
import LogoutIcons from "../assets/icons/logoutIcons.tsx";
import ProfileIcon from "../assets/icons/profileIcon.tsx";
import SidebarTicketIcon from "../assets/icons/sideBarTicketIcon.tsx";
import UserIcon from "../assets/icons/userIcon.tsx";

interface MenuItem {
  path: string;
  label: string;
  icon: React.FC;
}

export const menuItems: MenuItem[] = [
  {
    path: "/",
    label: "Tickets",
    icon: SidebarTicketIcon,
  },
  {
    path: "/users",
    label: "User Management",
    icon: UserIcon,
  },
  {
    path: "/userInfo",
    label: "My Profile",
    icon: ProfileIcon,
  },
  {
    path: "/changePassword",
    label: "Change Password",
    icon: ChangePasswordIcon,
  },
  {
    path: "/logout",
    label: "Log Out",
    icon: LogoutIcons,
  },
];
